import { Account } from '../models/account';
import { AccountTimeZoneViewModel } from './accountTimeZoneViewModel';
import { AccountConfigurationViewModel } from './bases/AccountConfiguration.viewmodel';
import { EmployeeSettingViewModel } from './employeeSettingViewModel';
import { FilterTypeSelectorObjectMappingViewModel } from './filters/filterTypeSelectorObjectMappingViewModel';
import { NotificationItemViewModel } from './notificationItemViewModel';

export class BaseConfigurationViewModel {
  title: string;
  accountId: number;
  accountGuid: string;
  logo: string;
  background: string;
  accountData: Account;
  appMode: string;
  allowedUploadTypes: string;
  maxFileSize: number;
  resourceFolderName: string;
  accountConfiguration: AccountConfigurationViewModel[];

  employeeToken: string;
  accountTimeZones: AccountTimeZoneViewModel[];
  employeeSettings: EmployeeSettingViewModel[];
  sortingModalMapping: FilterTypeSelectorObjectMappingViewModel[]
  unreadNotificationsCount: number;
  pendoApiKey: string;
  datadogApplicationId: string;
  datadogClientToken: string;

}
